(function () {
  var PRODUCTS_PER_PAGE = 24;

  var grid = document.querySelector('[data-collection-product-grid]');
  if (!grid) return;

  var amountElement = document.querySelector('.load-more-amount');
  var loadMoreLink = document.querySelector('loadmore-button');
  var isLoadMoreMode = !!amountElement && !!loadMoreLink;

  var totalProducts = 0;
  if (isLoadMoreMode) {
    var amountText = amountElement ? amountElement.textContent : '';
    var countMatch = amountText.match(/of\s+([\d,]+)/i);
    if (countMatch) {
      totalProducts = parseInt(countMatch[1].replace(/,/g, ''), 10) || 0;
    }
    if (!totalProducts && loadMoreLink) {
      var paginateEl = loadMoreLink.closest('[data-count]');
      if (paginateEl) totalProducts = parseInt(paginateEl.getAttribute('data-count'), 10) || 0;
    }
  }

  var visibleNormalCount = 0;
  var maxVisibleNormal = 0;
  var firstPageFeaturedCount = 0;
  var allHandles = new Set();
  var featuredHandlesSet = new Set();
  var featuredCards = [];
  var normalCards = [];
  var isLoading = false;
  var hasMorePages = true;

  // ========== URL 参数解析 ==========
  var params = new URLSearchParams(window.location.search);
  var featuredParam = params.get('featured_products');
  var featuredHandles = [];
  if (featuredParam) {
    featuredHandles = featuredParam.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    featuredHandles.forEach(function (h) { featuredHandlesSet.add(h); });
  }

  // ========== 清理重复 DOM ==========
  function removeDuplicateCards() {
    var seen = new Set();
    grid.querySelectorAll('[data-product-handle]').forEach(function (item) {
      var handle = item.getAttribute('data-product-handle');
      if (!handle || seen.has(handle)) {
        item.remove();
      } else {
        seen.add(handle);
      }
    });
  }

  // ========== 扫描第一页初始卡片 ==========
  function scanInitialCards() {
    removeDuplicateCards();
    var scannedFeatured = [];
    var scannedNormal = [];

    grid.querySelectorAll('[data-product-handle]').forEach(function (item) {
      var handle = item.getAttribute('data-product-handle');
      if (!handle) return;
      allHandles.add(handle);
      if (featuredHandlesSet.has(handle)) {
        item.setAttribute('data-featured', 'true');
        scannedFeatured.push({ handle: handle, element: item });
      } else {
        scannedNormal.push(item);
      }
    });

    var orderedFeatured = [];
    featuredHandles.forEach(function (targetHandle) {
      var idx = scannedFeatured.findIndex(function (x) { return x.handle === targetHandle; });
      if (idx > -1) {
        orderedFeatured.push(scannedFeatured[idx].element);
        scannedFeatured.splice(idx, 1);
      }
    });
    scannedFeatured.forEach(function (x) { orderedFeatured.push(x.element); });

    featuredCards = orderedFeatured;
    normalCards = scannedNormal;
    firstPageFeaturedCount = orderedFeatured.length;
  }

  // ========== 拉取不在第一页的置顶商品 ==========
  function fetchMissingFeatured() {
    var promises = featuredHandles.map(function (handle) {
      if (allHandles.has(handle)) return Promise.resolve();
      return fetchProductCard(handle).then(function (cardHtml) {
        if (!cardHtml) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = cardHtml.trim();
        var cardEl = wrapper.firstElementChild;
        if (!cardEl) return;
        var h = cardEl.getAttribute('data-product-handle');
        if (!h) return;
        allHandles.add(h);
        cardEl.setAttribute('data-featured', 'true');
        featuredCards.push(cardEl);
      }).catch(function () {});
    });

    return Promise.all(promises).then(function () {
      // 从 normalCards 中移除置顶商品并删除其 DOM 节点
      normalCards = normalCards.filter(function (card) {
        var handle = card.getAttribute('data-product-handle');
        if (featuredHandlesSet.has(handle)) {
          if (card.parentNode === grid) card.remove();
          return false;
        }
        return true;
      });

      // 按 URL 参数顺序重排 featuredCards
      var reordered = [];
      var remaining = featuredCards.slice();
      featuredHandles.forEach(function (targetHandle) {
        var idx = remaining.findIndex(function (c) { return c.getAttribute('data-product-handle') === targetHandle; });
        if (idx > -1) { reordered.push(remaining[idx]); remaining.splice(idx, 1); }
      });
      remaining.forEach(function (c) { reordered.push(c); });
      featuredCards = reordered;

      visibleNormalCount = normalCards.length;
      maxVisibleNormal = Math.max(0, PRODUCTS_PER_PAGE - featuredCards.length);
    });
  }

  // ========== 重新排列 DOM（置顶在前，普通在后） ==========
  function reorderDOM() {
    featuredCards.concat(normalCards).forEach(function (card) {
      grid.appendChild(card);
    });
  }

  // ========== 渲染 ==========
  function renderCurrentPage() {
    reorderDOM();

    var isLastPage = !hasMorePages;
    var showNormal = isLastPage ? normalCards.length : Math.min(visibleNormalCount, maxVisibleNormal);

    featuredCards.forEach(function (card) { card.style.display = ''; });

    normalCards.forEach(function (card, index) {
      card.style.display = index < showNormal ? '' : 'none';
    });

    updateLoadMoreText(showNormal, isLastPage);
    updateLoadMoreButton(isLastPage);
  }

  // ========== 更新文案 ==========
  function updateLoadMoreText(showNormal, isLastPage) {
    if (!isLoadMoreMode || !amountElement) return;
    var visibleCount = featuredCards.length + (isLastPage ? normalCards.length : showNormal);
    var displayTotal = totalProducts || visibleCount;
    var newAmount = Math.min(visibleCount, displayTotal);
    var template = amountElement.getAttribute('data-template') || 'Showing {{amount}} of {{count}} results';
    amountElement.textContent = template.replace('{{amount}}', newAmount).replace('{{count}}', displayTotal);
    var progressBar = document.querySelector('.load-more-progress-bar');
    if (progressBar && displayTotal) {
      progressBar.style.setProperty('--percent', (newAmount / displayTotal * 100) + '%');
      progressBar.style.setProperty('--amount', newAmount);
    }
  }

  // ========== 更新加载更多按钮 ==========
  function updateLoadMoreButton(isLastPage) {
    if (!loadMoreLink) return;
    loadMoreLink.style.display = isLastPage ? 'none' : '';
  }

  // ========== 加载更多 ==========
  function handleLoadMore(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (isLoading) return;

    var nextPageUrl = loadMoreLink.getAttribute('data-url');
    if (!nextPageUrl) {
      hasMorePages = false;
      renderCurrentPage();
      return;
    }

    isLoading = true;
    loadMoreLink.classList.add('loading');

    fetch(nextPageUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('加载失败');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-collection-product-grid]');

        if (!newGrid) {
          hasMorePages = false;
          renderCurrentPage();
          isLoading = false;
          loadMoreLink.classList.remove('loading');
          return;
        }

        var newItems = newGrid.querySelectorAll('[data-product-handle]');
        var addedCount = 0;

        newItems.forEach(function (item) {
          var handle = item.getAttribute('data-product-handle');
          if (!handle) return;
          if (featuredHandlesSet.has(handle)) return;
          if (allHandles.has(handle)) return;
          var clone = item.cloneNode(true);
          grid.appendChild(clone);
          allHandles.add(handle);
          normalCards.push(clone);
          addedCount++;
        });

        var newLink = doc.querySelector('loadmore-button');
        if (newLink && newLink.getAttribute('data-url') && addedCount > 0) {
          loadMoreLink.setAttribute('data-url', newLink.getAttribute('data-url'));
          hasMorePages = true;
        } else {
          hasMorePages = false;
        }

        if (addedCount > 0) {
          visibleNormalCount += addedCount;
          maxVisibleNormal += PRODUCTS_PER_PAGE;
        }

        renderCurrentPage();
        isLoading = false;
        loadMoreLink.classList.remove('loading');
      })
      .catch(function () {
        isLoading = false;
        loadMoreLink.classList.remove('loading');
      });
  }

  // ========== 绑定事件 ==========
  function bindLoadMore() {
    if (!isLoadMoreMode || !loadMoreLink) return;
    loadMoreLink.removeEventListener('click', handleLoadMore, true);
    loadMoreLink.addEventListener('click', handleLoadMore, true);
  }

  // ========== 工具函数 ==========
  function fetchProductCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : null; });
  }

  // ========== 启动 ==========
  scanInitialCards();

  grid.classList.add('is-loading');

  fetchMissingFeatured().then(function () {
    grid.classList.remove('is-loading');
    renderCurrentPage();
    bindLoadMore();
  });
})();